import { type SuretyAccountId, type SuretyBondId, type SuretyQuoteId } from "@inrev/common";

export const bondAttachmentsQueryKey = (bondId: SuretyBondId) =>
	["bonds", bondId, "attachments"] as const;

export const bondContractExtractionsQueryKey = (bondId: SuretyBondId) =>
	["bonds", bondId, "contractExtractions"] as const;

/** Bond forms are keyed by a bond id or, before issuance, by the bond request's quote id. */
export const bondFormFileUrlQueryKey = (id: SuretyBondId | SuretyQuoteId, asDownload?: boolean) =>
	asDownload === undefined
		? (["bondFormFileUrl", id] as const)
		: (["bondFormFileUrl", id, asDownload] as const);

export const bondPreviewsQueryKey = (accountId?: SuretyAccountId) =>
	accountId ? (["previews", "bonds", accountId] as const) : (["previews", "bonds"] as const);

export const bondQueryKey = (bondId: string) => ["bonds", bondId] as const;

export const bondTermsQueryKey = (bondId: SuretyBondId) => ["bonds", bondId, "terms"] as const;
